import { createFileRoute } from "@tanstack/react-router"
import { NbiSettingsPage } from "@/features/nbi/pages/SettingsPage"

export const Route = createFileRoute("/_authenticated/agent/application/settings")({
    component: NbiSettingsPage,
})
